import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LazyLoadingComponent} from "../../../shared/component/lazy-loading/lazy-loading.component";
import {TranslocoDirective} from "@ngneat/transloco";
import {FeaturedArticleComponent} from "../featured-article/featured-article.component";
import {RouterLink} from "@angular/router";
import {
    ArticleShortTemplateComponent
} from "../../../shared/component/article-short-template/article-short-template.component";
import {PageType} from "../../../shared/model/page-type";

@Component({
  selector: 'app-featured-article-card-desktop',
  standalone: true,
    imports: [CommonModule, LazyLoadingComponent, TranslocoDirective, RouterLink, ArticleShortTemplateComponent],
  templateUrl: './featured-article-card-desktop.component.html',
  styleUrl: './featured-article-card-desktop.component.scss'
})
export class FeaturedArticleCardDesktopComponent extends FeaturedArticleComponent{
  protected readonly PageType = PageType;
}
